import React, { useState, useEffect } from "react";
import EditEmployeePage from "../../../../../entities/DashboardPage/HRModule/Employees/Edit";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { employeeService } from "../../../../../api";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const EditEmployee = () => {
  const [data, setData] = useState("");
  const [imgUrl, setimgUrl] = useState("");
  const [loading, setLoading] = useState();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item } = state || {};
  const navigate = useNavigate();
  const [departmentData, setDepartmentData] = useState([]);
  const [document, setDocument] = useState(item?.docs);
  const [payslip, setPayslip] = useState([]);
  const [oneEmloyeeData, setOneEmployeeData] = useState({});
  const [projectList, setProjectList] = useState([]);
  const [operatorData, setOperatorData] = useState([]);

  useEffect(() => {
    getDepartment();
    getPayslipSetting();
    setDocData();
    getProjectList();
    getOperators();
  }, []);

  const setDocData = () => {
    setDocument((prevItems) => {
      const updatedItems = [...prevItems]; // Create a shallow copy of the array

      // Assume 'result.data' is an array of URLs and 'data' contains names
      item?.docs.forEach((url, index) => {
        if (updatedItems[index]) {
          // If the index exists, update the existing entry
          updatedItems[index] = {
            url: url?.url, // Assign the URL
            name: url?.name, // Assign the name
          };
        } else {
          // If the index does not exist, add a new entry
          updatedItems.push({
            url: url?.url,
            name: url?.name,
          });
        }
      });

      return updatedItems;
    });
  };
  const handleUrl = async (data) => {
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result) {
        setimgUrl(result.data[0]);
      }
    } catch (error) {
      // console.error("ssError occurred:", error);
    }
  };
  const handleMultipleUrl = async (data, i) => {
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result) {

        setDocument((prevItems) => {
          const updatedItems = [...prevItems]; // Create a shallow copy of the array

          if (updatedItems[i]) {
            // If the index exists, update the existing entry
            updatedItems[i].url = result?.data[0] || ""; // Assign the URL to the correct index
            updatedItems[i].name = data?.name || ""; // Assign the name to the correct index
          } else {
            // If the index does not exist, add a new entry
            updatedItems.push({
              url: result?.data[0] || "",
              name: data?.name || "",
            });
          }

          return updatedItems; // Return the updated array
        });
      }
    } catch (error) {
      // console.error("Error occurred:", error);
    }
  };

  // ------------------------------------------------------------------------------------------------
  // Calling a api for update a employee information
  // ------------------------------------------------------------------------------------------------

  const getOneEmployee = async (id) => {
    try {
      setLoading(true);
      const result = await AuthService.getEmployee(id);
      if (result?.success === true) {
        setOneEmployeeData(result?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const updateEmployeeInfo = async (
    data,
    user,
    mobile,
    cCode,
    emergency,
    emergencyCode,
    workplace,
    workplaceCode,
    nationalities
  ) => {
    try {
      setLoading(true);
      const result = await employeeService.update(
        data,
        imgUrl,
        user,
        document,
        mobile,
        cCode,
        emergency,
        emergencyCode,
        workplace,
        workplaceCode,
        nationalities
      );
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        getOneEmployee(item?._id);
        // navigate("/dashboard/manageStaff");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };


  const CountryCode = async (country) => {
    try {
      const result = await AuthService.getCountry(country);
      if (result?.success) {
        setData(result?.data);
      } else {
        setData("");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleNavigate = () => {
    navigate("/dashboard/manageStaff");
  };

  const getPayslipSetting = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipSetting();
      if (result?.success) {
        setPayslip(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  const getProjectList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProjectList();
      if (result?.success) {
        setProjectList(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getOperators = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getOperators(1, 100, true);
      if (result?.success) {
        const data =
          result?.data?.operator ||
          result?.data?.operators ||
          [];

        setOperatorData(data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleExportPdf = async (data) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleWorkerDataExport(data);
      if (result?.success) {
        showAlert(result?.message || "Export successfully", "success");
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message || "Export failed", "error");
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  }

  const handleExportSectionPdf = async (section) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.exportEmployeeSectionReport(item?._id, section);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert("Export failed", "error");
        return;
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = window.document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${section}_report.pdf`);
        window.document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        showAlert("PDF exported successfully", "success");
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "Export failed", "error");
    }
  }

  return (
    <EditEmployeePage
      loading={loading}
      handleMultipleUrl={handleMultipleUrl}
      registerEmployee={updateEmployeeInfo}
      userData={item}
      handleUrl={handleUrl}
      handleNavigate={handleNavigate}
      data={data}
      CountryCode={CountryCode}
      departmentData={departmentData}
      operatorData={operatorData}
      document={document}
      setDocument={setDocument}
      payslip={payslip}
      getOneEmployee={getOneEmployee}
      oneEmloyeeData={oneEmloyeeData}
      projectList={projectList}
      handleExportPdf={handleExportPdf}
      handleExportSectionPdf={handleExportSectionPdf}
    />
  );
};

export default EditEmployee;
